/* eslint-disable  */
import { Grid, Typography } from '@rentacenter/racstrap';
import { dofStyles } from '../JSStyles/dofStyles';
import { ReactComponent as TickIcon } from '../images/tick-icon.svg';
import DOFHeader from './Header';
import BreadCrumb from './BreadCrumb';
import { useTranslation } from 'react-i18next';
import { IdentityContext } from '../context/userInformation/IdentityContextProvider';
import React, { useContext } from 'react';





const DOFSubmitted: React.FC = () => {
    const { t } = useTranslation();
    const classes: any = dofStyles();
    let dofAuthSessionValue: any = window.sessionStorage.getItem("dofAuthValues");
    let sessionStorageValues: any = JSON.parse(dofAuthSessionValue);

    const context = useContext(IdentityContext);
    if (!context) {
        return <div> {t("Application is not available")}</div>;
    }

    const {
        liveLinessCompleted
    } = context;




    return (
        <Grid style={{ width: "100%", height: "80vh" }}>
            <DOFHeader
                identity={true}
                residence={true}
                income={false}
                reference={false}
                activeStep="Income"
            />
            <Grid style={{ marginTop: "7%" }}>


                <Grid className={`${classes.headingWidth} ${classes.mt30px}`}>
                    <TickIcon />
                </Grid>

                <Typography
                    className={`${classes.primaryFontColor} ${classes.responsiveFontTitle} ${classes.boldFont1} ${classes.p10px}`}
                    style={{ textAlign: 'center' }}

                >
                    {t("Application Submitted!")}

                </Typography>

                <Grid style={{ textAlign: 'center' }}>
                    <Typography
                        className={`${classes.responsiveFont14px} ${classes.p10px} ${classes.responsiveText}`}
                        style={{ textAlign: 'center', margin: '0 auto' }}
                    >
                        {liveLinessCompleted
                            ? t("The Liveliness Check has been send succesfully. Now you can close this tab.")
                            : (
                                <>
                                    {t("You're about to become part of the RAC family—your application was successfully submitted.")}<br />
                                    {t("Complete your process in-store with your valid INE and your mobile phone.")}
                                </>
                            )
                        }
                    </Typography>

                </Grid>


            </Grid>
        </Grid>
    );
};
export default DOFSubmitted;
